import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';
import {Select, Store} from '@ngxs/store';
import {Observable} from 'rxjs';
import {map, withLatestFrom} from 'rxjs/operators';
import {MessageGroups} from '../models/api/message-groups.model';
import {AuthActions} from '../state/auth/auth.actions';
import {AuthState} from '../state/auth/auth.state';

@Injectable()
export class UserMessagesResolver {
    @Select(AuthState.messages) messages$: Observable<MessageGroups>;

    constructor(private store: Store) {}

    resolve(route: ActivatedRouteSnapshot): Observable<MessageGroups> {
        return this.store.dispatch(new AuthActions.GetUserMessages()).pipe(
            withLatestFrom(this.messages$),
            map(([, messages]) => messages)
        );
    }
}
